import s from "classnames";
import m from "react";
import { Button as n } from "./basic-button.esm.js";
const f = ({
  dataTestId: t,
  size: a = "large",
  variant: e = "primary",
  className: r,
  ...o
}) => /* @__PURE__ */ m.createElement(
  n,
  {
    className: s("fuse-span-button", r),
    "data-testid": t,
    size: a,
    variant: e,
    ...o,
    as: "span"
  }
);
export {
  f as SpanButton
};
